import { render } from "./LocationGroupTable.vue?vue&type=template&id=1fb72e06"
import script from "./LocationGroupTable.vue?vue&type=script&lang=js"
export * from "./LocationGroupTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__